export default {
  settings: null,
  qdtComponents: null,
};
